export const IOS_URL =
  "https://itunes.apple.com/us/app/deliveries-tracker/id1266864859?ls=1&mt=8";

export const ANDROID_URL =
  "https://play.google.com/store/apps/details?id=com.spainexpresstracking";

export const SUPPORT_EMAIL = "carlosmsilva83@gmail.com";

export const TWITTER_URL = "https://twitter.com/racsol";